import { defineMessages } from 'react-intl';

export default defineMessages({
  selectPlaceholder: {
    id: 'neptune.MoneyInput.Select.placeholder',
    defaultMessage: 'Select an option...',
  },
  searchPlaceholder: {
    id: 'neptune.MoneyInput.Select.searchPlaceholder',
    defaultMessage: 'Type a currency or country',
    description: 'Default placeholder text for the search input in the currency selector.',
  },
  selectCurrencyLabel: {
    id: 'neptune.MoneyInput.Select.selectCurrencyLabel',
    defaultMessage: 'Select currency',
    description: 'Visually hidden label for the currency selector input.',
  },
});
